import React, { useContext, useEffect, useRef, useState } from 'react'
import antMessage from '../../../utils/extend/AntdNotification';
import systemConfig from '../../../config/systematic';
import { Button, Col, DatePicker, Form, Row, Select, Space, Switch, Table } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import DownloadExcel from '../../report/DownloadExcel';
import { SocketContext } from '../../../App';
import { useReactToPrint } from 'react-to-print';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

export default function MemberBalance() {
    let wmService: any = systemConfig.wmService;
    const [form] = Form.useForm();

    const [rows, setRows] = useState<Array<any>>([]);
    const [branchStoreData, setBranchStoreData] = useState<any>();
    const [branchStoreName, setBranchStoreName] = useState<any>("所有");

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const useContextData = useContext(SocketContext);
    const { contextData, } = useContextData;
    const [printScale, setPrintScale] = useState(1);
    const contentRef = useRef<HTMLDivElement>(null);
    const consumptionTime = Form.useWatch("consumptionTime", form) as any;

    /** 表头内容 */
    let columnsHead: Array<any> = [
        {
            title: "卡号",
            align: "center",
            header: "卡号",
            dataIndex: "id",
            key: "id",
        },

         {
            title: "姓名",
            align: "center",
            header: "姓名",
            dataIndex: "membershipName",
            key: "membershipName",
        },
          {
            title: "手机",
            align: "center",
            header: "手机",
            dataIndex: "contactNumber",
            key: "contactNumber",
        },
         {
            title: "卡类型",
            align: "center",
            header: "卡类型",
            dataIndex: "typeName",
            key: "typeName",
        },
          {
            title: "本金",
            align: "center",
            header: "本金",
            dataIndex: "balance",
            key: "balance",
        },
          {
            title: "赠送",
            align: "center",
            header: "赠送",
            dataIndex: "gifts",
            key: "gifts",
        },
          {
            title: "积分",
            align: "center",
            header: "积分",
            dataIndex: "points",
            key: "points",
        },
    
    ]
    useEffect(() => {
        if (contextData.currentBranchStoreId) {
            form.setFieldValue("brandStoreIds", [contextData.currentBranchStoreId])
            setBranchStoreName(contextData.currentBranchStoreName)
        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            }).then(res => {


                setBranchStoreData(res.data)
            })

            // fetchApi.GET(bmService,
            //   {
            //     apiId: 'generalData',
            //     apiVariable: 'MembershipStatuses',
            //     apiExtend: 'showLists'
            //   }).then(res => {
            //     if (res.success) {
            //     //   const { caCoMonStatus } = res.data
            //     //   setCaCoMonStatus(caCoMonStatus);
            //     }
            //   })

            // 
        }
        fetchData()

    }, []);


    const onFinish = () => {
        setIsLoading(true)
        form.validateFields()
            .then(async (values: any) => {
                fetchApi.GET(wmService, {
                    apiId: "membership",
                    apiExtend: 'membershipSnapshot',
                    apiData: {
                        ...values,
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },
                    }
                }).then((res) => {
                    console.log("res", res);
                    setIsLoading(false)
                    if (res.success) {
                        setRows(res.data)
                    }
                }).catch((err) => {
                    setIsLoading(false)
                    antMessage("error", JSON.stringify(err))
                })
            })
            .catch((err) => {
                setIsLoading(false)
                antMessage("error", "无法通过数据校验", "请输入所需数据")
            })
    }
    const changedBrandStoreIds = (e: any, option: any) => {
        let brandStoreName: Array<any> = []
        for (let i = 0; i < option?.length; i++) {
            brandStoreName.push(option[i].children)
        }


        setBranchStoreName(brandStoreName.join(","))

    }
    const handlePrint = useReactToPrint({
        contentRef,
        documentTitle: '会员汇总',


    });
    return (
        <>
            {/* <BranchStoreList setDeptData={setDeptData} setSbData={setSbData} form={form}></BranchStoreList> */}
            <Form
                form={form}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={6}>
                        <Form.Item
                            label="门店"
                            name="brandStoreIds"
                        >
                            <Select
                                onChange={changedBrandStoreIds}
                                mode="multiple"
                                fieldNames={{ value: "id", label: "branchStoreName" }}
                                allowClear
                                placeholder="门店"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={branchStoreData}
                            >
                            </Select>
                        </Form.Item>
                    </Col>

                   

                    <Col span={4}>
                        <Form.Item >
                            <Space>
                                <Button loading={isLoading} htmlType="submit">
                                    统计
                                </Button >


                                <Button onClick={() => DownloadExcel(rows, "memberBalance", {  columnsHead, branchStoreName })}>下载EXCEL文件</Button>
                                <Button onClick={handlePrint} type="default">打印</Button>
                            </Space>
                        </Form.Item>
                    </Col>


                </Row>

            </Form>

            <div style={{ marginTop: "20px" }}>
                <Table
                    pagination={false}
                        scroll={{ x: "100%", y: 1200 }}
                    // rowKey={(record: any, index: any) => {
                    //   console.log(record,index);
                    //   return 1
                    //   // return index
                    // }}
                    columns={columnsHead}
                    dataSource={rows}

                >
                </Table>

            </div>

            <div
                ref={contentRef}
                className="print-table"
                style={{
                    display: 'none',
                    transform: `scale(${printScale})`,
                    transformOrigin: 'top left',
                    width: printScale < 1 ? `${100 / printScale}%` : '100%'
                }}
            >
                <div style={{ fontSize: 18, textAlign: "center", marginBottom: 10 }}>会员余额</div>
                <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
                    {/* <div>  {queryCriteria?.timeNameA}: {moment(queryCriteria?.startTime).format('YYYY-MM-DD')}  至 {moment(queryCriteria?.endTime).format('YYYY-MM-DD')}</div> */}
                    {/* <div>部门：{queryCriteria.deptName}</div> */}
                    {/* <div>日期:{date ? `${dayjs(date[0]).format('YYYY-MM-DD')}~${dayjs(date[1]).format('YYYY-MM-DD')}` : "所有"}</div> */}
                    <div>分店:{branchStoreName}</div>



                </div>
                <Table
                    pagination={false}
                    // rowKey={(record: any, index: any) => {
                    //   console.log(record,index);
                    //   return 1
                    //   // return index
                    // }}
                    columns={columnsHead}
                    dataSource={rows}

                >
                </Table>

                <style dangerouslySetInnerHTML={{
                    __html: `
                                @media print {
                                   
                                    /* 2. 隐藏非打印元素 */
                                    .no-print, .screen-table {
                                        display: none !important;
                                    }
            
                                    /* 3. 显示打印表格 */
                                    .print-table {
                                        display: block !important;
                                    }
            
                                    /* 4. ✅ 核心：强制白底黑字 */
                                    .print-table table {
                                        border-collapse: collapse !important;
                                        width: 100% !important;
                                        table-layout: auto !important; /* 自动分配列宽 */
                                    }
            
                                    /* 表头：白底黑字加粗 */
                                    .print-table .ant-table-thead > tr > th {
                                        background: #ffffff !important; /* 强制白底 */
                                        color: #000000 !important; /* 强制黑字 */
                                        border: 1px solid #000000 !important;
                                        font-weight: bold !important;
                                        font-size: 12px !important;
                                        padding: 6px 8px !important;
                                    }
            
                                    /* 单元格：白底黑字 */
                                    .print-table .ant-table-tbody > tr > td {
                                        background: #ffffff !important; /* 强制白底 */
                                        color: #000000 !important; /* 强制黑字 */
                                        border: 1px solid #000000 !important;
                                        font-size: 11px !important;
                                        padding: 4px 8px !important;
                                        white-space: nowrap !important; /* 防止文字换行撑大表格 */
                                    }
            
                                    /* 5. 防止内容跨页截断 */
                                    .print-table tr {
                                        page-break-inside: avoid !important;
                                    }
            
                                    /* 6. 强制打印背景色（解决浏览器省墨模式问题） */
                                    body {
                                        -webkit-print-color-adjust: exact !important;
                                        print-color-adjust: exact !important;
                                    }
            
                                    /* 7. 清除Antd残留样式 */
                                    .print-table .ant-table-cell-fix-left,
                                    .print-table .ant-table-cell-fix-right {
                                        position: static !important;
                                    }
                                    .print-table .ant-table-container,
                                    .print-table .ant-table-content,
                                    .print-table .ant-table-body {
                                        overflow: visible !important;
                                        max-height: none !important;
                                    }
                                }
                            `
                }} />
            </div>

        </>
    )
}
